export const addTFConsoleMethods = (methods: Record<string, (...args: any) => void>) => {
	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-expect-error Property is created here
	window.tfConsole = { ...window.tfConsole, ...methods };
};
